import { c as _c } from "react/compiler-runtime";
import { Copyright } from '@phosphor-icons/react';
import { memo, type Ref } from 'react';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';
import { cx } from '../../cx';
import { uiTestId } from '../../test-ids';
import { Flag } from '../flag/flag';
import { LoadingImage } from '../loading-image/loading-image';
import type { SliderImage } from './image-slider';
const imageVariants = tv({
  base: 'size-full',
  variants: {
    objectFit: {
      cover: 'object-cover',
      contain: 'object-contain'
    }
  },
  defaultVariants: {
    objectFit: 'cover'
  }
});
export type ImageSliderItemProps = VariantProps<typeof imageVariants> & {
  imageClassName?: string;
  liClassName?: string;
  image: SliderImage;
  imageSizes: string;
  showCopyright?: boolean;
  priority?: boolean;
  reduceTransitions?: boolean;
  ref?: Ref<HTMLImageElement>;
};
export const ImageSliderItem = memo(function ImageSliderItem(props) {
  const $ = _c(20);
  const {
    ref,
    priority,
    reduceTransitions
  } = props;
  let t0;
  if ($[0] !== props.liClassName) {
    t0 = cx("relative w-full flex-none snap-center text-center", props.liClassName);
    $[0] = props.liClassName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.imageClassName || $[3] !== props.objectFit) {
    t1 = imageVariants({
      className: props.imageClassName,
      objectFit: props.objectFit
    });
    $[2] = props.imageClassName;
    $[3] = props.objectFit;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.image.alt || "";
  const t3 = priority ? "eager" : "lazy";
  let t4;
  if ($[5] !== priority || $[6] !== props.image.url || $[7] !== props.imageSizes || $[8] !== reduceTransitions || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <LoadingImage ref={ref} className={t1} src={props.image.url} alt={t2} sizes={props.imageSizes} draggable={false} reduceTransitions={reduceTransitions} priority={priority} loading={t3} fill={true} />;
    $[5] = priority;
    $[6] = props.image.url;
    $[7] = props.imageSizes;
    $[8] = reduceTransitions;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props.image.copyright || $[14] !== props.showCopyright) {
    t5 = props.showCopyright && props.image.copyright && <div className="absolute bottom-3 left-3" data-testid={uiTestId("ImageSlider.copyright")}><Flag Icon={Copyright}>{props.image.copyright}</Flag></div>;
    $[13] = props.image.copyright;
    $[14] = props.showCopyright;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t0 || $[17] !== t4 || $[18] !== t5) {
    t6 = <li className={t0}>{t4}{t5}</li>;
    $[16] = t0;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
});
ImageSliderItem.displayName = 'ImageSliderItem';